var map = {
	"./access.jpg": "ca88",
	"./backgound.png": "a568",
	"./bg.png": "dc97",
	"./center.png": "7119",
	"./close.png": "04b3",
	"./history.png": "1c5f",
	"./img1.png": "a497",
	"./img2.png": "5f56",
	"./map-poster.png": "01d9",
	"./music_btn.png": "44e4",
	"./qrcode.png": "a596",
	"./share.png": "cff1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";